import { useEffect, useState } from 'react'

import Auth from 'store/auth'
import useAlert from 'store/common/useAlert'

import { handleSubscription } from 'utils/handleLecturSubscription'
import { getAxiosSingle, postAxiosSingle } from 'pages/api/axios'
import { BASE_URL, SubscibeURL } from 'constants/url'
import { ILectur } from 'constants/types/common.types'

const useLectorsSubscription = (Lecturs: ILectur[] = [], place: string) => {
  const { isAuthorized } = Auth.useAuth()
  const { setSingleAlert } = useAlert()
  const [lectors, setLectors] = useState(Lecturs)

  const subscribeLector = async (id: number) => {
    const index = lectors.findIndex((item) => item.id === id)
    const lectorId = lectors[index].id
    const isSubscribed = lectors[index].subscribed

    const setSubscription = (curIndex: number) => {
      return (subStatus: boolean) => {
        setLectors((curLectors) => {
          const newLectors = [...curLectors]
          newLectors[curIndex].subscribed = subStatus
          return newLectors
        })
      }
    }
    await handleSubscription(
      isSubscribed as boolean,
      place,
      lectorId as number,
      setSubscription(index),
      setSingleAlert
    )
  }

  const subscribeAll = () => {
    const lectorsIds = lectors.map((lector) => {
      const url = `${SubscibeURL.LECTUR}/${lector.id}`
      return postAxiosSingle(url)
    })

    Promise.all(lectorsIds).then(() => {
      setLectors((curLectors: ILectur[]) => {
        const newLectors = [...curLectors]
        newLectors.map((item) => {
          item.subscribed = true
          return item
        })
        return newLectors
      })
    })
  }

  useEffect(() => {
    const getData = async () => {
      const lectorsIds = Lecturs.map((lector) => getAxiosSingle(`${BASE_URL.LECTUR}/${lector.id}`))
      Promise.all(lectorsIds).then((results) => {
        const data = results.map((item, index) => ({
          ...Lecturs[index],
          subscribed: item.subscribed || false,
        }))
        setLectors(data)
      })
    }
    if (isAuthorized) {
      getData()
    }
  }, [isAuthorized, JSON.stringify(Lecturs)])

  return {
    lectors,
    subscribeAll,
    subscribeLector,
  }
}

export default useLectorsSubscription
